export { default } from './full-match-fitment';
